import React, { Component } from 'react';
import './App.css';
import ScreenContext from './ScreenContext';
import img_elFacebook from './images/SocialLinks_elFacebook_978545.png';
import img_elTwiter from './images/SocialLinks_elTwiter_1043157.png';
import img_elTelegram from './images/SocialLinks_elTelegram_237495.png';

export default class MenuTop extends Component {

  static contextType = ScreenContext;

  // This component doesn't use any properties

  constructor(props) {
    super(props);
    
    this.state = {
    };
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  componentDidUpdate(prevProps, prevState) {
  }

  onClick_elButton = async () => {
    window.open('https://app.gitbook.com/o/vkknHaonxzw7n64IJCHD/s/DLXAv9p0U57YfFX9oLjM/', '_blank');
  
  }
  
  
  onClick_elFacebook = async () => {
    window.open('https://discord.gg/AqdrCJHd9K', '_blank');
  
  }
  
  
  onClick_elTwiter = async () => {
    window.open('https://twitter.com/mnemosynekey', '_blank');
  
  }
  
  
  onClick_elTelegram = async () => {
    window.open('https://t.me/+_7pQquge0yZkNDg0', '_blank');
  
  }
  
  
  render() {
    
    const style_elButton = {
      display: 'block',
      fontSize: 24.0,
      color: '(null)',
      textAlign: 'center',
      backgroundColor: 'transparent',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    const style_elFacebook = {
      height: 'auto',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    const style_elTwiter = {
      height: 'auto',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    const style_elTelegram = {
      height: 'auto',
      cursor: 'pointer',
      pointerEvents: 'auto',
     };
    
    return (
      <div className="MenuTop">
        <div className="layoutFlow">
          <div className="flowRow flowRow_MenuTop_elButton_147520">
          <div className="elButton">
            <button className="font-caesarDressingRegular" style={style_elButton} onClick={this.onClick_elButton} >
              {this.context.locStrings.component1_button_147520}
            </button>
          </div>
          
          </div>
        </div>
        
        <div className="foreground">
          <img className="elFacebook" style={style_elFacebook} src={img_elFacebook} alt="" onClick={this.onClick_elFacebook}  />
          <img className="elTwiter" style={style_elTwiter} src={img_elTwiter} alt="" onClick={this.onClick_elTwiter}  />
          <img className="elTelegram" style={style_elTelegram} src={img_elTelegram} alt="" onClick={this.onClick_elTelegram}  />
        </div>
      </div>
    )
  }
  
}
